const getBaseLik = process.env.REACT_APP_SHARE_URL
const baseLink = `${getBaseLik}#/`
// 'https://logicalchat.com/#/'
// const baseLink = 'http://localhost:3000/#/'

//----------overview------------------
const overViewDetailsLink = `${baseLink}dashboard/overview/detail/`

//----------group------------------
const groupDetailsLink = `${baseLink}dashboard/group/detail/`

//----------feed------------------
const feedDetailsLink = `${baseLink}dashboard/group/feed/detail/`

//----------category------------------
const categoryDetailsLink = `${baseLink}dashboard/category/groups/`

export {
    overViewDetailsLink,
    groupDetailsLink,
    feedDetailsLink,
    categoryDetailsLink,
}